import { AnimationUI, createAnimationUI } from './animationUI';

export class Animation {
  public constructor(private ui: AnimationUI) {
    this.registerEvents()
  }

    private registerEvents() {
        this.ui.isInFirstScreen(this.onEnterviewport.bind(this));
        window.addEventListener('scroll', () => {
          this.onScroll();
        });
    }

    private onEnterviewport() {
      this.ui.submitAnimation();
    }

    private onLeaveviewport() {

    }

    private onScroll() {
      this.ui.isInViewport(() => this.onEnterviewport());
    }
}


export function initAnimation() {
  const uiInstance = createAnimationUI();
  const instance = uiInstance.map((uiInstance: AnimationUI) => {
    return new Animation(uiInstance);
  });
}
